import * as angular from "angular";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Feature } from "../../models/feature.model";
import { FeatureService } from "../../services/feature.service";
import { PermissionCheck } from "../../shared/permission";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";

let IphoneMockupComponent = {
    selector: "vcIphoneMockup",
    templateUrl: "/angular/components/customize/iphone-mockup.component.html",
    restrict: "EA",
    replace: true,
    bindings: {
        permission: "=",
        feature: "=",
        tab: "=",
    },
    controller: class IphoneMockupController {
        // * bindings for typescript compiler *
        public permission: any;
        public feature: Feature;
        public tab: string;
        // ************************************

        public permissionProvider;
        public fieldDataProvider;
        public canvassStatusDataProvider;
        public reception;
        public ratingNames;
        public loading;
        public surveys;
        public signatureFeature;
        public talkingPointCategories;

        private readonly $q: any;
        public readonly __env: any;
        private readonly surveyDataProvider: SurveyDataProvider;
        private readonly consentTypeDataProvider: ConsentTypeDataProvider;
        private readonly talkingPointDataProvider: TalkingPointDataProvider;
        private readonly featureService: FeatureService;

        constructor(
            __env: any,
            $q: any,
            PermissionCheck: PermissionCheck,
            FieldDataProvider: FieldDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            SurveyDataProvider: SurveyDataProvider,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            TalkingPointDataProvider: TalkingPointDataProvider,
            FeatureService: FeatureService
        ) {
            this.$q = $q;
            this.featureService = FeatureService;
            this.permissionProvider = PermissionCheck;
            this.fieldDataProvider = FieldDataProvider;
            this.canvassStatusDataProvider = CanvassStatusDataProvider;
            this.surveyDataProvider = SurveyDataProvider;
            this.consentTypeDataProvider = ConsentTypeDataProvider;
            this.talkingPointDataProvider = TalkingPointDataProvider;
            this.__env = __env;

            this.reception = 4;
            this.ratingNames = {
                1: "veryUnlikely",
                2: "unlikely",
                3: "neutral",
                4: "likely",
                5: "veryLikely",
            };

            this.permissionProvider.getConsentSettings().then((settings) => {
                this.signatureFeature = new Feature(
                    this.$q,
                    this.featureService,
                    settings.SIGNATURE.attributes
                );
            });

            this.talkingPointDataProvider.getCategories().then((categories) => {
                this.talkingPointCategories = categories;
            });

            this.consentTypeDataProvider.all();
        }

        $onInit() {
            this.surveyDataProvider.getSurveyLists().then((surveys) => {
                this.loading = false;
                this.surveys = surveys;
            });
        }
    },
};

angular
    .module("customize")
    .component(IphoneMockupComponent.selector, IphoneMockupComponent);
